export default __webpack_public_path__ + "static/pie-de98d2e57ef25abc6d293ea9819d1cb0.jpeg";